import React, { useEffect, useRef, useState } from 'react';
import IconButton from '@material-ui/core/IconButton';
import { makeStyles } from '@material-ui/core/styles';
import ExpandMore from '@material-ui/icons/ExpandMore';

const useStyles = makeStyles(theme => ({
  root: {
    marginBottom: theme.spacing(2),
  },
  label: {
    display: 'block',
    fontSize: '0.875rem',
    fontWeight: 500,
    color: '#9e9e9e',
    marginBottom: theme.spacing(1),
  },
  button: {
    width: '100%',
    backgroundColor: '#1E1E1E',
    border: '1px solid #2A2A2A',
    borderRadius: '12px',
    padding: '12px 16px',
    textAlign: 'left',
    color: '#e0e0e0',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    cursor: 'pointer',
    transition: 'border-color 0.2s ease-in-out',
    '&:hover': {
      borderColor: '#e6616a',
    },
  },
  value: {
    color: '#ffffff',
  },
  placeholder: {
    color: '#9e9e9e',
  },
  icon: {
    transition: 'transform 0.2s ease-in-out',
    color: 'white',
  },
  iconOpen: {
    transform: 'rotate(180deg)',
  },
  list: {
    position: 'absolute',
    top: '100%',
    left: 0,
    width: '100%',
    marginTop: theme.spacing(1),
    backgroundColor: '#1E1E1E',
    border: '1px solid #2A2A2A',
    borderRadius: '12px',
    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
    zIndex: 10,
    overflow: 'hidden',
    listStyle: 'none',
    padding: 0,
    margin: 0,
  },
  listItem: {
    padding: '12px 16px',
    cursor: 'pointer',
    transition: 'background-color 0.2s ease-in-out',
    color: '#ffffff',
    '&:hover': {
      backgroundColor: '#2A2A2A',
    },
  },
  listItemActive: {
    backgroundColor: '#e6616a',
  },
}));

const ModernDropdown = ({ label, value, onChange, options, isMultiSelect = false }) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);

  useEffect(() => {
    const onDocClick = e => {
      if (!rootRef.current) {
        return;
      }
      if (!rootRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('click', onDocClick);
    return () => document.removeEventListener('click', onDocClick);
  }, []);

  const handleSelect = optionValue => {
    if (isMultiSelect) {
      const newValue = [...(value || [])];
      const index = newValue.indexOf(optionValue);
      if (index > -1) {
        newValue.splice(index, 1);
      } else {
        newValue.push(optionValue);
      }
      onChange(newValue);
    } else {
      onChange(optionValue);
      setOpen(false);
    }
  };

  const selectedLabels = isMultiSelect
    ? value?.length > 0
      ? `[${value.length}] Selected`
      : `Select ${label}`
    : options.find(option => option.value === value)?.label;

  return (
    <div className={classes.root} ref={rootRef}>
      <label className={classes.label}>{label}</label>
      <div style={{ position: 'relative' }}>
        <button type="button" onClick={() => setOpen(v => !v)} className={classes.button}>
          <span className={value ? classes.value : classes.placeholder}>{selectedLabels || `Select ${label}`}</span>
          <IconButton size="small">
            <ExpandMore className={`${classes.icon} ${open ? classes.iconOpen : ''}`} />
          </IconButton>
        </button>
        {open && (
          <ul className={classes.list}>
            {options.map((option, idx) => (
              <li
                key={idx}
                onClick={() => handleSelect(option.value)}
                className={`${classes.listItem} ${
                  isMultiSelect ? (value?.includes(option.value) ? classes.listItemActive : '') : option.value === value ? classes.listItemActive : ''
                }`}
              >
                {option.label}
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default ModernDropdown;
